import get from 'lodash/get'

export const hasDependencies = category => !!['models', 'lands', 'notes'].find(dependency => get(category, `${dependency}.length`, 0) > 0)
